'use client';

import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { Check, Minus } from 'lucide-react';

const checkboxVariants = cva(
  'peer flex shrink-0 cursor-pointer items-center justify-center rounded-sm border border-primary shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring data-disabled:cursor-not-allowed data-disabled:opacity-50 data-checked:bg-primary data-checked:text-primary-foreground data-indeterminate:bg-primary data-indeterminate:text-primary-foreground',
  {
    variants: {
      size: {
        sm: 'h-3.5 w-3.5 [&_svg]:size-3',
        default: 'h-4 w-4 [&_svg]:size-3.5',
        lg: 'h-5 w-5 [&_svg]:size-4',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

type CheckboxProps = CheckboxPrimitive.Root.Props &
  VariantProps<typeof checkboxVariants> & {
    className?: string;
  };

const Checkbox = ({ className, size = 'default', indeterminate, ...props }: CheckboxProps) => {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(checkboxVariants({ size, className }))}
      indeterminate={indeterminate}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current"
      >
        {indeterminate ? <Minus /> : <Check />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};

export { Checkbox, checkboxVariants };
